export default "__VITE_ASSET__cbbeab28__"